"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCommentSection = void 0;
function makeCommentSection(sectionSchema) {
    throw new Error(`Comments aren't supported yet. Cannot process ${sectionSchema.title}`);
}
exports.makeCommentSection = makeCommentSection;
//# sourceMappingURL=commentSection.js.map